import React from 'react';

const AboutSection = () => {

  return (
    <>
         {/* about-section */}
         <section className="about-section">
            <div className="auto-container">
                <div className="row clearfix">
                    <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                        <div className="image_block_one">
                            <div className="image-box mr_30 pr_130 pb_100">
                                <div className="shape" style={{backgroundImage: `url('assets/images/shape/shape-1.png')`}}></div>
                                <figure className="image"><img src="assets/images/team/Sunshine_eye_care_1_solo_at_machine.jpeg" alt="" /></figure>
                                <div className="text p_absolute r_0 b_0">
                                    <h2>13+</h2>
                                    <h4>Years of Experience</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                        <div className="content_block_one">
                            <div className="content-box ml_30">
                                <div className="sec-title left p_relative d_block mb_25">
                                    <span className="sub-title">Who We Are?</span>
                                    <h2>One Stop Destination for Advanced Eyecare</h2>
                                    <p className="stats-text">
                                    20000+ Surgeries ✦ 13+ Years Practice ✦ 200+ Squint Aligned
                                    </p>
                                </div>
                                <div className="text p_relative d_block">
                                    <p>Our Eye Care Hospital Center is more than just a medical facility, it is a welcoming and comfortable environment for our patients. <br/>
                                    With a focus on providing exceptional care and an emphasis on patient satisfaction, our center is truly a great place for eye care.<br/>
                                    We strive to make every visit a positive experience, from the warm and friendly staff to the modern and inviting atmosphere.</p>
                                </div>
                                <div className="inner-box">
                                    <div className="row clearfix">
                                        <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                                            <div className="single-item">
                                                <h3>Our Mission</h3>
                                                <ul className="list-style-one clearfix">
                                                    <li>Quality eye care services for our patients.</li>
                                                    <li>Advanced technology and education for our staff.</li>
                                                    <li>Patient satisfaction through compassionate and personalized care.</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                                            <div className="single-item">
                                                <h3>Our Vision</h3>
                                                <ul className="list-style-one clearfix">
                                                    <li>Exceptional quality of service and patient satisfaction.</li>
                                                    <li>Continuous learning and innovation with the latest technology and techniques.</li>
                                                    <li>Promotion of eye health and wellness through education and outreach.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* about-section end */}
    </>
    );
  }
  
  export default AboutSection;